"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IrisCore = exports.EventParam = exports.CallIrisApiResult = void 0;
const IrisApiEngineImpl_1 = require("./IrisApiEngineImpl");
class CallIrisApiResult {
    constructor(code, data) {
        this.code = code;
        this.data = data;
    }
    static success(irisReturnCode = 0, resultCode = 0, rawResult) {
        let result;
        if (rawResult) {
            result = rawResult;
        }
        else {
            result = `{"result": ${resultCode}}`;
        }
        return new CallIrisApiResult(irisReturnCode, result);
    }
    static failed(irisReturnCode, resultCode = 0, rawResult) {
        let result;
        if (rawResult) {
            result = rawResult;
        }
        else {
            result = `{"result": ${resultCode}}`;
        }
        return new CallIrisApiResult(irisReturnCode, result);
    }
}
exports.CallIrisApiResult = CallIrisApiResult;
class EventParam {
    constructor(event, data, data_size, result, buffer, length, buffer_count, eventHandle = '0') {
        this.event = event;
        this.data = data;
        this.data_size = data_size;
        this.result = result;
        this.buffer = buffer;
        this.length = length;
        this.buffer_count = buffer_count;
        this.eventHandle = eventHandle;
    }
}
exports.EventParam = EventParam;
function createIrisApiEngine() {
    let engine = new IrisApiEngineImpl_1.IrisApiEngineImpl();
    if (window.__AGORA_IRIS_API_ENGINE_LIST__ === undefined ||
        window.__AGORA_IRIS_API_ENGINE_LIST__.length === 0) {
        window.__AGORA_IRIS_API_ENGINE_LIST__ = [];
        window.__AGORA_IRIS_API_ENGINE_LIST__.push(engine);
    }
    return engine;
}
function disposeIrisApiEngine(engine_ptr) {
    engine_ptr.dispose();
    if (window.__AGORA_IRIS_API_ENGINE_LIST__ !== undefined) {
        window.__AGORA_IRIS_API_ENGINE_LIST__ = window.__AGORA_IRIS_API_ENGINE_LIST__.filter((engine) => engine !== engine_ptr);
    }
    // IrisApiEngine.instance = null;
    return 0;
}
function callIrisApi(apiEngine, apiParam) {
    return apiEngine.callIrisApi(apiParam);
}
function createIrisEventHandler(event_handler) {
    return IrisApiEngineImpl_1.IrisEventHandlerImpl.create(event_handler);
}
exports.IrisCore = {
    createIrisApiEngine: createIrisApiEngine,
    disposeIrisApiEngine: disposeIrisApiEngine,
    callIrisApi: callIrisApi,
    createIrisEventHandler: createIrisEventHandler,
    CallIrisApiResult: CallIrisApiResult,
    EventParam: EventParam,
};
